import * as React from "react";
import {
  Box,
  Stack,
  Button,
  ButtonGroup,
  Typography,
} from "@mui/material";
import {
  ChartContainer,
  ChartsGrid,
  ChartsTooltip,
  ChartsXAxis,
  ChartsYAxis,
  LinePlot,
  MarkPlot,
} from "@mui/x-charts";

export default function SimpleLineChart({ data = [], updateFilter }) {
  const series = [{ type: "line", dataKey: "percentage", color: "#ffd828ff" }];

  const hasData = Array.isArray(data) && data.length > 0 && Array.isArray(series) && series.length > 0;
  const yAxisConfig = hasData
    ? [{ id: "leftAxis", width: 50 }]
    : [{ id: "leftAxis", width: 50, min: 0, max: 100 }];

  return (
    <Stack sx={{ width: "100%" }} spacing={2}>
      
      {/* ✅ Line Chart */}
      <Box sx={{ width: "100%", position: "relative", height: 400 }}>
          <ChartContainer
            dataset={data}
            series={series}
            xAxis={[
              {
                scaleType: "band",
                dataKey: "date",
                label: "Date",
              },
            ]}
            yAxis={yAxisConfig}
            height={400}
          >
            <ChartsGrid horizontal />
            <LinePlot />
            <MarkPlot />
            <ChartsXAxis />
            <ChartsYAxis axisId="leftAxis" label="Percentage (%)" />
            <ChartsTooltip />
          </ChartContainer>
    
      </Box>
    </Stack>
  );
}
